import React from 'react'

function ClickHere() {
  return (
    <>
     <header className="icici-header1">
            {/* <img
              src={require("../Assets/logo.png")}
              alt="ICICI Bank"
              className="icici-logo"
            /> */}
          </header>
          <div className="p-3">Comming Soon Click Here / <a href="/icici">Back to Home</a></div>

    </>
  )
}

export default ClickHere